import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../../widgets/loader";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import { updateSelectedParameters } from "../../../../../utils/ResponseConver";
import { LpgCargo } from "../../components/CargoMachinCom/LpgCargo";

export const LpgCargoList = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [LPG_Data, set_LPG_Data] = useState([]);

  const GET_SHIP_LPG_LISTS = async () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);

      const res = await post(ApiURL.list_cargo_machinery_lpg_st, FORM_DATA);
      if (res?.status === true) {
        const updatedData = (res.lpg_cargo_parameters_data || []).map((item) => ({
          ...item,
          selected_parameters: updateSelectedParameters(item?.selected_parameters || []),
        }));

        set_LPG_Data(updatedData);
      }
    } catch (error) {
      console.error("Error LPG list:", error);
    } finally {
      set_loader(false);
    }
  };



  useEffect(() => {
    GET_SHIP_LPG_LISTS();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {LPG_Data && LPG_Data?.length > 0 ? (
              <>
                {LPG_Data?.map((_items) => (
                  <LpgCargo
                    key={_items.id} // add key for performance
                    eng_log_basic_id={eng_log_basic_id}
                    _items={_items}
                  />
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};
